<template>
  <box-wrapper class="w-full">
    <template #text>
      <p ref="textBox" :class="{[`clamp-${clampLines}`]: !isShownAll}"
         class="w-full text-black-soft leading-loose"
      >
        {{ text }}
      </p>
    </template>
    <template #footer>
      <p v-if="!isTextClamped" class="mt-4 block font-medium cursor-pointer text-primary"
         @click="isShownAll = !isShownAll">
        {{ buttonLabel }}
      </p>
    </template>
  </box-wrapper>
</template>

<script>
import BoxWrapper from '@/components/base-components/BoxWrapper'

export default {
  name: 'ExpandableTextBox',

  components: {
    BoxWrapper
  },

  props: {
    text: {
      type: String,
      required: true
    },
    clampLines: {
      type: [Number, String],
      default: 3
    }
  },

  data() {
    return {
      isShownAll: false,
      isTextClamped: false
    }
  },

  watch: {
    text: {
      immediate: true,
      handler() {
        this.isShownAll = false
        this.setIsTextClamped()
      }
    }
  },

  computed: {
    buttonLabel() {
      return this.isShownAll ? 'See less' : 'See more'
    }
  },

  methods: {
    async setIsTextClamped() {
      await this.$nextTick()
      const { clientHeight, scrollHeight } = this.$refs.textBox || {}
      this.isTextClamped = clientHeight >= scrollHeight
    }
  }
}
</script>
